import { render, staticRenderFns } from "./TicketNew.vue?vue&type=template&id=de1606f0&"
import script from "./TicketNew.vue?vue&type=script&lang=js&"
export * from "./TicketNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports